<script setup lang="ts">
import { X } from "lucide-vue-next"
import { Button } from "@/components/ui/button"

defineProps<{
  isOpen: boolean
  title: string
  devices: MediaDeviceInfo[]
  pendingDeviceId: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'confirm'): void
  (e: 'select', deviceId: string): void
}>()
</script>

<template>
  <div v-if="isOpen"
       class="absolute inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div class="bg-card border rounded-xl w-[420px] max-w-[90%] p-5 shadow-2xl">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-lg font-semibold">{{ title }}</h3>
        <button class="text-muted-foreground hover:text-foreground" @click="emit('close')"><X class="size-5" /></button>
      </div>
      <div class="space-y-1 max-h-[300px] overflow-y-auto mb-4">
        <button v-for="device in devices" :key="device.deviceId"
                class="w-full text-left px-3 py-2 rounded-md hover:bg-accent flex items-center justify-between"
                :class="{ 'bg-accent': pendingDeviceId === device.deviceId }"
                @click="emit('select', device.deviceId)">
          <span class="truncate">{{ device.label || 'Устройство ' + device.deviceId }}</span>
          <div v-if="pendingDeviceId === device.deviceId" class="size-2 rounded-full bg-primary" />
        </button>
        <div v-if="devices.length === 0" class="text-sm text-muted-foreground p-3">Устройства не найдены</div>
      </div>
      <div class="flex justify-end gap-2">
        <Button variant="secondary" @click="emit('close')">Отмена</Button>
        <Button :disabled="!pendingDeviceId" @click="emit('confirm')">Подтвердить</Button>
      </div>
    </div>
  </div>
</template>
